import React, { memo } from "react"
import styled from "styled-components"
import SvgIcon from "../../zzz/atoms/icons/svg-icon"
import Check from "../../zzz/atoms/icons/files/check.jsx"

// ======================
// 	🧱🧱 COMPONENT 🧱🧱
// ======================
const Option = memo(
  ({ image, title, text, link, toggleFilter, filterActive }) => {
    // If "link" is defined, the button should just link to a page and not filter anything
    const callBackFunction = () => {
      if (!link) {
        return toggleFilter()
      }
    }

    // Convenience function because this needs to be wrapped in an a tag dynamically
    const Contents = () => {
      console.log(image)
      return (
        <>
          {image && <img src={image} />}
          <h3>
            {title}{" "}
            {filterActive && (
              <SvgIcon SvgComponent={Check} hue="success" shade="dark" />
            )}
          </h3>
          {text && <p>{text}</p>}
        </>
      )
    }

    return (
      <OptionWrap active={filterActive} onClick={callBackFunction}>
        {link ? (
          <a href={link} rel="noopener noreferrer" target="_blank">
            <Contents />
          </a>
        ) : (
          <Contents />
        )}
      </OptionWrap>
    )
  }
)

// ====================
// 	💅🏼💅🏼 STYLES 💅🏼💅🏼
// ====================
const OptionWrap = styled.div`
  padding: 20px;
  background-color: ${({ active }) => (active ? "#223247" : "#F6F6F6")};
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 6px -5px rgba(119, 132, 142, 0.19);
  }
  &,
  h3 {
    color: ${({ active }) => (active ? "white" : "#223247")};
  }
  h3 {
    font-weight: 500;
  }
`
// const BedAnimation = styled(BgImage)`
//   grid-area: secondary;
//   position: relative;
// `

export default Option
